import { buildStorageCriteriaParams } from './searchCriteria';
import type { SearchCriteria } from '../model/types';

/**
 * Сохраняет последние критерии поиска в localStorage под ключом продукта
 * (`tourCriteria`, `tourCriteria/tury`, `tourCriteria__hotelOffers`,
 * `tourCriteria__railwayTours`). Пишет ровно `SearchCriteriaParams` —
 * тот самый формат, который читает обратно `getLastSearchCriteria`, поэтому
 * критерии восстанавливаются при следующем открытии формы.
 *
 * Порт `ls.set('tourCriteria', toLocalStorageTourCriteria(...))` из legacy
 * `index.js` (`searchTours` / `searchHotTours`): даты остаются в ISO
 * (`yyyy-MM-dd`) — как в модели формы и как ожидает `buildSearchCriteria`.
 */
export default function setLastSearchCriteria(key: string, criteria: SearchCriteria): void {
  if (typeof localStorage === 'undefined') {
    return;
  }

  try {
    localStorage.setItem(key, JSON.stringify(buildStorageCriteriaParams(criteria)));
  } catch {
    // Запись в localStorage может упасть (квота / приватный режим) — не роняем поиск.
  }
}
